module.exports = __WEBPACK_EXTERNAL_MODULE_240__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/add/observable/from"
// module id = 240
// module chunks = 0